import {
  Button,
  Checkbox,
  List,
  Modal,
  ListItemButton,
  ListItemText,
  ListItem,
} from "@mui/material";
import { Box } from "@mui/system";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "../Modal/Modal.css";
import "./TableColumnModal.css";
import React, { useState } from "react";
import PropTypes from "prop-types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "#fff",
  border: "1px solid #000",
  boxShadow: 24,
  p: 0,
};

const TableColumnModal = (props) => {
  const [colsState, setColsState] = useState(props.selection);

  const handleToggle = (fieldName) => {
    let newColumns = colsState.map((el) => {
      if (el.fieldName === fieldName) {
        if (el.isSelected) {
          el.isSelected = false;
        } else {
          el.isSelected = true;
        }
      }
      return el;
    });
    setColsState(newColumns);
  };

  const isEmpty = () => {
    let selected = colsState?.filter((el) => el.isSelected) ?? [];
    return selected.length <= 1;
  };

  return (
    <>
      <Modal
        open={props.isOpen}
        onClose={() => {
          props.onCancelTableColumnSelection();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="custom-modal">
          <div className="modal-header">
            <div className="modal-header-left">Select columns to display</div>
            <button
              type="button"
              data-testid="cancel-selection-cross"
              className="modal-header-right"
              onClick={() => props.onCancelTableColumnSelection()}
              style={{
                cursor: "pointer",
                background: "transparent",
                border: "none",
                padding: 0,
              }}
              aria-label="Close table column selection"
            >
              <CloseOutlinedIcon data-testid="CloseTableColumnSelectionPopup" />
            </button>
          </div>
          <div className="modal-body change-view-body">
            <List>
              {colsState?.map(
                (el) =>
                  el.showInSelection &&
                  el.label !== "" && (
                    <ListItem key={el.fieldName} disablePadding>
                      <ListItemButton
                        onClick={() => handleToggle(el.fieldName)}
                        dense
                      >
                        <Checkbox
                          checked={el.isSelected}
                          inputProps={{
                            "data-testid": `tab-col-${el.fieldName}`,
                          }}
                        />
                        <ListItemText primary={el.label} />
                      </ListItemButton>
                    </ListItem>
                  )
              )}
            </List>
          </div>
          <div className="modal-footer">
            <div>
              <Button
                data-testid="cancel-selection"
                variant="outlined"
                className="action-button mr-4"
                name="cancel-table-selection-columns"
                onClick={() => {
                  props.onCancelTableColumnSelection();
                }}
              >
                Cancel
              </Button>
              <Button
                data-testid="apply-selection"
                variant="contained"
                className="action-button"
                disabled={isEmpty()}
                onClick={() => {
                  props.onSaveTableColumnSelection(
                    props.componentName,
                    colsState
                  );
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};
TableColumnModal.propTypes = {
  selection: PropTypes.arrayOf(
    PropTypes.shape({
      fieldName: PropTypes.string.isRequired,
      label: PropTypes.string,
      isSelected: PropTypes.bool,
      showInSelection: PropTypes.bool,
    })
  ),
  isOpen: PropTypes.bool,
  onCancelTableColumnSelection: PropTypes.func.isRequired,
  onSaveTableColumnSelection: PropTypes.func.isRequired,
  componentName: PropTypes.string,
};

TableColumnModal.defaultProps = {
  selection: [],
  isOpen: false,
  componentName: "",
};

export default TableColumnModal;
